var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "member-cancellation" },
    [
      _c(
        "div",
        { staticClass: "page-header" },
        [
          _c("span", { staticClass: "page-title" }, [
            _vm._v("管理中心- 用户注销清单"),
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "add-btn",
              attrs: { type: "primary" },
              on: { click: _vm.handleAdd },
            },
            [_vm._v("\n      添加注销清单\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "search-area" },
        [
          _c(
            "el-form",
            {
              staticClass: "search-form",
              attrs: { inline: true, model: _vm.searchForm },
            },
            [
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    staticClass: "search-input",
                    attrs: { placeholder: "搜索手机号", clearable: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "prefix",
                        fn: function () {
                          return [_c("i", { staticClass: "el-icon-search" })]
                        },
                        proxy: true,
                      },
                    ]),
                    model: {
                      value: _vm.searchForm.mobile,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "mobile", $$v)
                      },
                      expression: "searchForm.mobile",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v("搜索")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-area" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "cancellation-table",
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "id",
                  label: "ID",
                  align: "center",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "userId",
                  label: "用户ID",
                  align: "center",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "mobile",
                  label: "手机号",
                  align: "center",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "aliuid",
                  label: "支付宝unionId",
                  align: "center",
                  "min-width": "200",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "unionid",
                  label: "微信unionId",
                  align: "center",
                  "min-width": "200",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "reason",
                  label: "注销原因",
                  align: "center",
                  "min-width": "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "reason-content" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(scope.row.reason) +
                              "\n          "
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "regTime",
                  label: "注册日期",
                  align: "center",
                  "min-width": "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.formatTime(scope.row.regTime)) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "addTime",
                  label: "申请/审核",
                  align: "center",
                  "min-width": "160",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "time-info" }, [
                          _c("div", { staticClass: "apply-time" }, [
                            _vm._v(_vm._s(_vm.formatTime(scope.row.addTime))),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "auditStatus",
                  label: "审核状态",
                  align: "center",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getStatusTagType(scope.row.auditStatus),
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.getStatusText(scope.row.auditStatus)
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "auditName",
                  label: "操作员",
                  align: "center",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  align: "center",
                  "min-width": "120",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.checkAuditStatus(scope.row)
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "danger", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleApprove(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n            审核\n          ")]
                            )
                          : _c("span", { staticClass: "processed-status" }, [
                              _vm._v("已处理"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-area" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.currentPage,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "添加注销清单",
            visible: _vm.addDialogVisible,
            width: "600px",
            "before-close": _vm.handleDialogClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.addDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "addFormRef",
              attrs: {
                model: _vm.addForm,
                rules: _vm.addFormRules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "用户ID", prop: "userId" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入用户ID" },
                    model: {
                      value: _vm.addForm.userId,
                      callback: function ($$v) {
                        _vm.$set(_vm.addForm, "userId", $$v)
                      },
                      expression: "addForm.userId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "手机号", prop: "mobile" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入手机号" },
                    model: {
                      value: _vm.addForm.mobile,
                      callback: function ($$v) {
                        _vm.$set(_vm.addForm, "mobile", $$v)
                      },
                      expression: "addForm.mobile",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "支付宝unionId", prop: "aliuid" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入支付宝unionId" },
                    model: {
                      value: _vm.addForm.aliuid,
                      callback: function ($$v) {
                        _vm.$set(_vm.addForm, "aliuid", $$v)
                      },
                      expression: "addForm.aliuid",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "微信unionId", prop: "unionid" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入微信unionId" },
                    model: {
                      value: _vm.addForm.unionid,
                      callback: function ($$v) {
                        _vm.$set(_vm.addForm, "unionid", $$v)
                      },
                      expression: "addForm.unionid",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "注销原因", prop: "reason" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder: "请输入注销原因",
                      maxlength: "200",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.addForm.reason,
                      callback: function ($$v) {
                        _vm.$set(_vm.addForm, "reason", $$v)
                      },
                      expression: "addForm.reason",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.addDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleSubmitAdd },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "审核注销申请",
            visible: _vm.approveDialogVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.approveDialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "approve-content" }, [
            _c("p", [
              _c("strong", [_vm._v("用户ID：")]),
              _vm._v(_vm._s(_vm.currentApproveItem.userId)),
            ]),
            _vm._v(" "),
            _c("p", [
              _c("strong", [_vm._v("手机号：")]),
              _vm._v(_vm._s(_vm.currentApproveItem.mobile)),
            ]),
            _vm._v(" "),
            _c("p", [
              _c("strong", [_vm._v("注销原因：")]),
              _vm._v(_vm._s(_vm.currentApproveItem.reason)),
            ]),
            _vm._v(" "),
            _c("p", [
              _c("strong", [_vm._v("申请时间：")]),
              _vm._v(_vm._s(_vm.formatTime(_vm.currentApproveItem.addTime))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "confirm-message" }, [
              _c("p", { staticClass: "warning-text" }, [
                _vm._v("请确认余额及赠金已清零，再继续注销。"),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "medium" },
                  on: {
                    click: function ($event) {
                      _vm.approveDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "success", size: "medium" },
                  on: { click: _vm.handleApproveSubmit },
                },
                [_vm._v("通过审核")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }